export default "__VITE_ASSET__D0kIAmKA__"